module.exports = __webpack_public_path__ + "static/media/paymentError.28ee0020.svg";